type Props = {
  href: string
}

const MARK = '/brand/perfect-predict-mark.png'

export function TradeBrandLogo({ href }: Props) {
  return (
    <a className="tl-logo" href={href} aria-label="Perfect Predict">
      <img className="tl-logo__mark" src={MARK} alt="" width={40} height={40} />
      <span className="tl-logo__text">Perfect Predict</span>
    </a>
  )
}
